export default {
  vision_blog: "fraudvision 博客".toUpperCase(),
  stay_turned__: "关注 FraudVision 最新动态，一手掌握全局。".toUpperCase(),
};
